module.exports = __webpack_public_path__ + "static/media/monitors.ab226c20.svg";